package com.yogaaicoach.pages.auth

import com.yogaaicoach.common.ui.components.*
import com.yogaaicoach.pages.auth.LoginActionsViewModel
import com.yogaaicoach.user.AppViewModel
import kotlinx.coroutines.awaitCancellation
import react.FC
import react.Props
import react.dom.html.ReactHTML.a
import react.dom.html.ReactHTML.button
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.h1
import react.dom.html.ReactHTML.p
import react.dom.html.ReactHTML.span
import react.useEffectOnce
import web.cssom.ClassName
import web.dom.ElementId
import web.dom.document

internal external interface LoginPageProps : Props {
    var viewModel: LoginActionsViewModel
    var appViewModel: AppViewModel
    var onNavigateToEmailSignIn: () -> Unit
}

private data class Benefit(val icon: FC<Props>, val title: String, val text: String)

private val benefits = listOf(
    Benefit(CheckCircleIcon, "Personalized Practice", "Adaptive sessions tuned to your abilities and goals."),
    Benefit(ScheduleIcon, "Fits Your Lifestyle", "Practice anytime — your schedule, your rules."),
    Benefit(ShowChartIcon, "Smart Progress Tracking", "Your plan evolves automatically based on your practice history and engagement."),
)

internal val LoginPage = FC<LoginPageProps> { props ->
    useEffectOnce {
        document.documentElement.classList.add(ClassName("no-overscroll"))
        try {
            awaitCancellation()
        } finally {
            document.documentElement.classList.remove(ClassName("no-overscroll"))
        }
    }

    div {
        className = ClassName("hero")
        div { className = ClassName("hero-overlay") }
        div {
            className = ClassName("hero-content")

            h1 {
                className = ClassName("login-hero-title")
                +"Yoga "
                span { className = ClassName("hero-title-word"); +"Training " }
                +"Built Around Your Body"
            }
            p { className = ClassName("login-hero-subtitle"); +"Your goals, your pace, your plan — a program that adapts to you." }
            a { className = ClassName("start-now-button"); href = "#signin-card"; +"Start now" }

            div {
                className = ClassName("benefits")
                benefits.forEach { benefit ->
                    div {
                        className = ClassName("benefit-card")
                        benefit.icon {}
                        div {
                            p { className = ClassName("benefit-title"); +benefit.title }
                            p { className = ClassName("benefit-text"); +benefit.text }
                        }
                    }
                }
            }

            div {
                id = ElementId("signin-card")
                className = ClassName("signin-card")
                p { className = ClassName("signin-title"); +"Start your personalized yoga plan" }
                p { className = ClassName("signin-subtitle"); +"Begin with a free trial • No credit card required" }

                button {
                    className = ClassName("signin-button google")
                    onClick = { props.viewModel.signInWithGoogle(props.appViewModel::handleUserLoginSuccess) }
                    GoogleIcon {}
                    span { +"Sign in with Google" }
                }
                button {
                    className = ClassName("signin-button facebook")
                    onClick = { props.viewModel.signInWithFacebook(props.appViewModel::handleUserLoginSuccess) }
                    FacebookIcon {}
                    span { +"Sign in with Facebook" }
                }
                button {
                    className = ClassName("signin-button email")
                    onClick = {
                        props.viewModel.logEmailSignInClicked()
                        props.onNavigateToEmailSignIn()
                    }
                    EmailIcon {}
                    span { +"Sign in with email" }
                }

                p {
                    className = ClassName("legal-links")
                    +"By continuing, you agree to our "
                    a { href = "terms-of-service.html"; +"Terms of Service" }
                    +" and "
                    a { href = "privacy-policy.html"; +"Privacy Policy" }
                    +"."
                }
            }
        }
    }
}
